import { EPageActionTypes, EPageType } from '../../types/page/pageType';
import { TReduxActions } from '../../types/redux';

export const defaultPageState = {
  pageType: EPageType.Tenant,
  queryParams: {
    dealtype: EPageType.Tenant,
  },
  isStickyBtnVisible: false,
};

export function pageReducer(state = defaultPageState, { type, payload }: TReduxActions) {
  if (type === EPageActionTypes.SetPageType) {
    return {
      ...state,
      pageType: payload,
    };
  }

  if (type === EPageActionTypes.SetPageQueryParams) {
    return {
      ...state,
      queryParams: payload,
    };
  }

  if (type === EPageActionTypes.ToggleStickyScrollBtn) {
    return {
      ...state,
      isStickyBtnVisible: payload,
    };
  }

  return state;
}
